import checkout from './checkout'
import Vue from 'vue'
import { loadMercadoPago } from "@mercadopago/sdk-js"

export default async (amount, mercadopagoPublicKey, setCarregamento, setComponenteAtual, setPagamentoStatus, tratarErro) => {
    try {
        await loadMercadoPago();
        const mp = new window.MercadoPago(mercadopagoPublicKey, { locale: 'pt-BR' })
        const bricksBuilder = mp.bricks()

        const renderPaymentBrick = async (bricksBuilder) => {
            const settings = {
                initialization: {
                    amount: amount,
                },
                customization: {
                    paymentMethods: {
                        creditCard: "all",
                        debitCard: "all",
                        bankTransfer: "all",
                    },
                },
                callbacks: {
                    onReady: () => {
                        setCarregamento(false)
                        setComponenteAtual('payment')
                    },
                    onSubmit: async ({ formData }) => {
                        try {
                            const response = await checkout(formData)
                            const pagamento = response.data.retornoPagamento
                            const id = pagamento.id

                            window.paymentBrickController.unmount()
                            setCarregamento(true)

                            const renderStatusScreenBrick = async (bricksBuilder) => {
                                const settings = {
                                    initialization: {
                                        paymentId: id,
                                    },
                                    callbacks: {
                                        onReady: () => {
                                            setCarregamento(false)
                                            setComponenteAtual('status')
                                            setPagamentoStatus(response.status)
                                        },
                                        onError: (error) => {
                                            window.console.error(error);
                                        },
                                    },
                                }
                                window.statusScreenBrickController = await bricksBuilder.create(
                                    'statusScreen',
                                    'statusScreenBrick_container',
                                    settings,
                                )
                            }
                            renderStatusScreenBrick(bricksBuilder)

                            verificarPix(id, pagamento, setCarregamento, renderStatusScreenBrick, bricksBuilder, tratarErro)
                        } catch (error) {
                            tratarErro()
                            window.console.log(error)
                        }
                    },
                    onError: (error) => {
                        window.console.error(error)
                        tratarErro()
                    },
                },
            }
            window.paymentBrickController = await bricksBuilder.create('payment', 'paymentBrick_container', settings)
            if (!window.paymentBrickController) {
                tratarErro()
            }
        }
        renderPaymentBrick(bricksBuilder)
    } catch (error) {
        window.console.log(error)
        tratarErro()
    }
}

function verificarPix(id, pagamento, setCarregamento, renderStatusScreenBrick, bricksBuilder, tratarErro) {
    var pending = (pagamento.payment_method_id == "pix" && pagamento.status == "pending") ? true : false
    var validadePix = pagamento.date_of_expiration
    var interval = setInterval(async function () {
        await Vue.axios.get(`/mercadopago/${id}/status`).then((result) => pending = result.data.pending)

        if (!pending) {
            clearInterval(interval)
            window.statusScreenBrickController.unmount()
            setCarregamento(true)
            renderStatusScreenBrick(bricksBuilder)
            return
        }

        if (validadePix < Date.now()) {
            clearInterval(interval)
            tratarErro('PIX')
            return
        }
    }, 35000)
}